"use strict";

exports.__esModule = true;
exports.Modal = void 0;
var React = _interopRequireWildcard(require("react"));
var _ModalSt = require("./Modal.st.css");
var _dataHooks = require("./dataHooks");
var _keyCodes = require("../../../common/keyCodes");
var _reactDom = require("react-dom");
var _TPAComponentsConfig = require("../../TPAComponentsConfig");
var _focusTrap = _interopRequireWildcard(require("focus-trap"));
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/internal/Modal/Modal.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Modal = ({
  className,
  shouldCloseOnClickOutside = true,
  shouldCloseOnEsc = true,
  focusTrap = true,
  isOpen = false,
  forceBWTheme = false,
  appendToBody = false,
  onRequestClose,
  children,
  'data-hook': dataHook
}) => {
  const {
    mobile: isMobile
  } = React.useContext(_TPAComponentsConfig.TPAComponentsContext);
  const contentRef = React.useRef(null);
  React.useEffect(() => {
    if (!isMobile && isOpen && shouldCloseOnEsc) {
      document.addEventListener('keyup', onEscKeyup);
      return () => document.removeEventListener('keyup', onEscKeyup);
    }
    return undefined;
  }, [isOpen, isMobile, shouldCloseOnEsc]);

  // @ts-expect-error
  React.useEffect(() => {
    if (isOpen && focusTrap && contentRef.current) {
      const focusTrapInstance = _focusTrap.createFocusTrap(contentRef.current, {
        escapeDeactivates: false,
        clickOutsideDeactivates: shouldCloseOnClickOutside,
        returnFocusOnDeactivate: true
      });
      try {
        focusTrapInstance.activate();
      } catch (err) {}
      return () => focusTrapInstance.deactivate();
    }
    return undefined;
  }, [isOpen, focusTrap]);
  const onEscKeyup = e => {
    if (e.keyCode === _keyCodes.KEY_CODES.Esc) {
      onClose();
    }
  };
  const onClose = () => onRequestClose == null ? void 0 : onRequestClose();
  const renderModal = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: _ModalSt.classes.overlay,
    "data-hook": _dataHooks.MODAL_DATA_HOOKS.OVERLAY,
    onClick: shouldCloseOnClickOutside ? onClose : undefined,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("section", {
    className: _ModalSt.classes.modal,
    "data-hook": _dataHooks.MODAL_DATA_HOOKS.CONTENT,
    ref: contentRef,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }, children));
  const modalComponent = /*#__PURE__*/React.createElement(_TPAComponentsConfig.TPAComponentsConsumer, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 5
    }
  }, () => /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: (0, _ModalSt.st)(_ModalSt.classes.root, {
      isOpen,
      forceBWTheme
    }, className),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }, isOpen ? renderModal() : null));
  return appendToBody && typeof document !== 'undefined' ? /*#__PURE__*/(0, _reactDom.createPortal)(modalComponent, document.body) : modalComponent;
};
exports.Modal = Modal;
Modal.displayName = 'Modal';
//# sourceMappingURL=Modal.js.map